import React, {useEffect, useState, useRef} from 'react';
import renderHTML from 'react-render-html';
import gsap from 'gsap';
import _ from 'lodash';
import './VideoChoice.sass';
import VideoPlayer from '../../VideoPlayer';
import StandardButton from "../../ui/Button/StandardButton";
import apiJSON from "../../../api/apiJSON";
import AudioGraph from "../../ui/AudioGraph/AudioGraph";

const VideoChoice = ({data, completed, next}) => {
    const [scenarioCounter, setScenarioCounter] = useState(0);
    const [choiceCounter, setChoiceCounter] = useState(0);
    const [feedback, setFeedback] = useState(false);
    const [selectedChoice, setSelectedChoice] = useState({});
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [trackingArray, setTrackingArray] = useState([]);
    const [choiceSetComplete, setChoiceSetComplete] = useState(false);
    const [activeDisplay,setActiveDisplay] = useState(null);

    const choiceColumn = useRef(null);

    // load activity json file
    const jsonData = apiJSON.get(data);
    const {scenarios} = jsonData;
    const scenario = scenarios[scenarioCounter];

    console.log("VideoChoice rerendering")

    useEffect(() => {
        initTrackingArray();
    }, []);


    useEffect(() => {
        console.log("useEffect(choiceSetComplete")
        console.log("choiceSetComplete:" + choiceSetComplete)
        if (choiceSetComplete) {
            gsap.set(".StandardButton", {visibility: "visible", opacity: 1});
            gsap.from(".StandardButton", {x: 1200, ease: "expo-easeOut", delay: 1})
        } else {
            gsap.set(".StandardButton", {opacity: 0});
        }
    }, [choiceSetComplete])

    useEffect(() => {
        setTimeout(function () {
            gsap.set('.main-container,.video-choice-col,.instructions', {
                visibility: 'visible',
            });
        }, 0);

        gsap.from('.main-container', {x: -1600, ease: "expo.out"});
        gsap.from('.video-choice-col', {x: 1600, ease: "expo.out"});
        gsap.from('instructions', {x: -1600, ease: "expo.out"})
    }, [choiceCounter]);

    const finished = () => {
        completed();
    };

    const handleSelect = (index) => {
        console.log("handleSelect(choice:" + index + ")")
        gsap.to('.main-container', {x: -1600, ease: "expo.out"});
        gsap.to('.video-choice-col', {left: '50px', right: 'auto', ease: "expo.out"});
        gsap.to('.instructions', {x: -800, ease: "expo.out"})
        // linkage, required, style, video, label, info, feedback(body,title)
        const {choices} = scenario.choiceSet[choiceCounter];
        setSelectedChoice(choices[index]);
        setFeedback(choices);
        setSelectedIndex(index);
        updateTracking(index);
    };

    const updateTracking = (index) => {
        console.log("updateTracking(" + index + ")")
        let dupe = [...trackingArray];
        dupe[index] = 1;
        if (checkChoiceSetComplete(scenario.choiceSet[choiceCounter].choices, dupe)) {
            setChoiceSetComplete(true);
        }
        setTrackingArray(dupe);
    }

    const checkChoiceSetComplete = (choices, tracking) => {
        console.log("checkChoiceSetComplete()")
        console.log("trackingArray:" + trackingArray)
        for (let i = 0; i < choices.length; i++) {
            let c = choices[i];
            let t = tracking[i];
            console.log("c:" + c);
            console.log(c.required)
            console.log(t)
            if (c.required && t == 0) {
                console.log("not complete!")
                return false;
            }
        }
        return true;
    }

    const initTrackingArray = () => {
        if (!scenario) return;
        let tracking = [];
        _.forEach(scenario.choiceSet[choiceCounter].choices, () => {
            tracking.push(0)
        });
        setTrackingArray(tracking);
    }

    const goTo = (linkage) => {
        console.log("goTo(" + linkage + ")")
        const {choiceSet} = scenario;
        setSelectedIndex(-1);
        const index = _.findIndex(choiceSet, (choice) => choice.id === linkage);
        if (index !== -1) {
            gsap.set('.video-choice-col', {right: '180px', left: 'auto'});
            gsap.to('.instructions', {x: 0, ease: "expo.out"})
            setChoiceCounter(index);
            setFeedback(false);
            setChoiceSetComplete(false);
            initTrackingArray();
        } else {
            //gsap.set('.StandardButton', {visibility: 'hidden'});
            finished();
            next();
        }
    };

    const enableSelect = (index) => {
        let btn = document.querySelector("#choice-btn" + index);
        if (!feedback) {
            btn.className = "select-btn";
        }
    }


    return (
        <div className="videoChoice">
            {(scenario && !feedback && scenario.choiceSet[choiceCounter].video) && (
                <div className="main-container">
                    <VideoPlayer
                        autoplay={scenario.autoPlay}
                        src={scenario.choiceSet[choiceCounter].video}
                    />
                </div>
            )}
            {(scenario && !feedback && scenario.choiceSet[choiceCounter].audio) && (
                <div className="main-container">
                    <AudioGraph data={scenario.choiceSet[choiceCounter].audio}/>
                </div>

            )}
            {scenario.choiceSet[choiceCounter].choices ? (
                <div ref={choiceColumn}
                     className="video-choice-col">
                    {scenario.choiceSet[choiceCounter].choices.map((choice, index) => {
                        return (
                            <div key={index}
                                 className="video-choice-item">
                                {(index === selectedIndex) ? (
                                    <button id={"choice-btn" + index}
                                            className="select-btn selected">
                                        {"SELECTED"}
                                    </button>) : (
                                    <button id={"choice-btn" + index}
                                            className={feedback ? "select-btn" : "select-btn disabled"}
                                            onClick={() => handleSelect(index)}>
                                        {"SELECT"}
                                    </button>)}
                                <div className={index === selectedIndex ? "video-holder selected" : "video-holder"}
                                     onClick={() => {
                                         enableSelect(index)
                                     }}>
                                    <VideoPlayer src={choice.video}/>
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : null}
            {scenario && feedback ? (
                <div className="video-choice-feedback">
                    {selectedChoice.feedback.title &&
                        <div className="feedback-header" style={selectedChoice.style || {}}>
                          {selectedChoice.feedback.title}
                         </div>
                    }

                        {selectedChoice.feedback.body&&
                        <div className={"feedback-body"}>
                            {renderHTML(selectedChoice.feedback.body)}
                        </div> }
                    <StandardButton className="StandardButton absolute right-0 bottom-0"
                                    style={{
                                        opacity: 0
                                    }}
                                    data={"CONTINUE"}
                                    callback={goTo}
                                    params={selectedChoice.linkage}/>
                </div>
            ) : null}

            {scenario.instructions ? (
                <div className="instructions">
                    {renderHTML(scenario.instructions.main)}
                </div>
            ) : null}
        </div>
    );
};

export default VideoChoice;
